import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

// First, and for effect only: it initialises i18next and sets the document's `lang`.
// Catalogues are bundled rather than fetched, so this completes synchronously and no
// screen ever renders a key — which is also why there is no Suspense boundary here.
// See src/i18n/index.ts.
import './i18n'

// The gate and not `App`: nothing renders the record until `GET /api/auth/session` has
// answered, and the login screen is what stands there until it does (PHASE-0.md §2.1).
import { SessionGate } from './auth/SessionGate'
import { REFERENCE_LANGUAGE, i18next, setLanguage } from './i18n'
import { loadOfferedLanguages } from './i18n/offeredLanguages'
import './index.css'

// Which languages this box offers (DECISIONS.md #56). Not awaited: the login screen renders at once
// with every bundled language and narrows when the answer arrives. If the language in force is not
// offered, back to Swedish.
void loadOfferedLanguages().then((offered) => {
  if (!offered.includes(i18next.language)) {
    void setLanguage(REFERENCE_LANGUAGE)
  }
})

const container = document.getElementById('root')
if (!container) {
  throw new Error('Root element #root is missing from index.html')
}

createRoot(container).render(
  <StrictMode>
    <SessionGate />
  </StrictMode>,
)
